import React from "react"

// delete this package
import { documentToReactComponents } from "@contentful/rich-text-react-renderer"

export const CHANNELS = [
  {
    name: "Home",
    path: "/",
  },
  {
    name: "Health & Wellness",
    path: "/health-and-wellness/",
  },
  {
    name: "Biology",
    path: "/biology/",
  },
  // {
  //   name: "Stories",
  //   path: "/stories/",
  // },
  {
    name: "Product Education",
    path: "/product-education/",
  },
  {
    name: "Tips & Tricks",
    path: "/tips-and-tricks/",
  },
  {
    name: "The Menopause Edit",
    path: "/the-menopause-edit/",
  },
]
